import React from "react";
import { Link } from "react-router-dom";
import { BedDouble, Bath, LandPlot, ArrowRight } from "lucide-react";
import { imgUrl } from "../lib/api";

export const PropertyCard = ({ listing }) => {
  const imgs = listing.images || [];
  const img = imgs[listing.cover_index] || imgs[0];
  return (
    <Link
      to={`/properties/${listing.id}`}
      data-testid={`property-card-${listing.id}`}
      className="group block border border-ivory/10 bg-[#242424] transition-shadow duration-500 hover:shadow-[0_20px_40px_rgba(0,0,0,0.45)]"
    >
      <div className="relative aspect-[4/3] overflow-hidden">
        {img && (
          <img
            src={imgUrl(img)}
            alt={listing.title}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          />
        )}
        <div className="absolute left-4 top-4 flex gap-2">
          <span className="border border-ivory/20 bg-charcoal/85 px-3 py-1 text-[0.65rem] font-semibold uppercase tracking-[0.18em] text-ivory backdrop-blur-sm">
            {listing.status}
          </span>
          {listing.is_sample && (
            <span className="border border-ivory/40 bg-charcoal/60 px-3 py-1 text-[0.65rem] font-semibold uppercase tracking-[0.18em] text-ivory/85 backdrop-blur-sm">
              Sample
            </span>
          )}
        </div>
      </div>

      <div className="p-6">
        <p className="eyebrow text-ivory/60">
          {listing.district} · {listing.location}
        </p>
        <h3 className="mt-3 font-serif text-2xl leading-snug text-ivory">{listing.title}</h3>
        <p className="mt-2 font-serif text-2xl font-semibold text-ivory" data-testid={`property-price-${listing.id}`}>
          {listing.price_display}
        </p>

        <div className="mt-5 flex flex-wrap items-center gap-x-5 gap-y-2 border-t border-ivory/10 pt-4 text-sm text-ivory/60">
          <span className="flex items-center gap-1.5">
            <BedDouble className="h-4 w-4 text-ivory/50" /> {listing.beds}
          </span>
          <span className="flex items-center gap-1.5">
            <Bath className="h-4 w-4 text-ivory/50" /> {listing.baths}
          </span>
          {listing.land_area > 0 && (
            <span className="flex items-center gap-1.5">
              <LandPlot className="h-4 w-4 text-ivory/50" /> {listing.land_area.toLocaleString()} sqft land
            </span>
          )}
          <span className="text-ivory/45">{listing.type}</span>
        </div>

        <span className="mt-5 inline-flex items-center gap-2 text-[0.75rem] font-semibold uppercase tracking-[0.2em] text-ivory/80 transition-colors duration-300 group-hover:text-ivory">
          View residence
          <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" />
        </span>
      </div>
    </Link>
  );
};
